import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class DateService {

    //From human format to Date
    parseHumanEnteredDate(dateString: string | null | undefined): {isValid: boolean, value?: Date | undefined }{
        if(dateString != null && (dateString.length <= 10 && dateString.length >= 8)){
            const [day, month, year] = dateString.split("/").map(Number);
            if (year < 1000){
                return {
                    isValid: false
                }               
            }
            const parsedDate = new Date(year, month - 1, day);
            if (parsedDate instanceof Date){

                return {
                    value: parsedDate,
                    isValid: true
                };
            }
        }

        return {
            isValid: false
        }
    }


    //SQL format to Date
    parseSQLDateTime(sqlDateString: string | null | undefined): {isValid: boolean, value?: Date | undefined }{
        if(sqlDateString != null){
            const dateComponents = this.getDateValuesFromSqlDateTime(sqlDateString);
            if (!dateComponents.isvalid){
                return {
                    isValid: false
                };
            }

            const parsedDate = new Date(dateComponents.year, dateComponents.month - 1, dateComponents.day);

            if (parsedDate.getFullYear() < 1000){
                return {
                    isValid: false
                }               
            }
            if (parsedDate instanceof Date){

                return {
                    value: parsedDate,
                    isValid: true
                };
            }
        }

        return {
            isValid: false
        }
    }

    getDateValuesFromSqlDateTime(sqlDateString: string): {isvalid: boolean, year?: number, month?: number, day?: number}{
        if (sqlDateString == null || sqlDateString.length < 10){
            return {
                isvalid: false
            };
        }

        if (sqlDateString.indexOf(" ") === -1 && sqlDateString.indexOf("T") === -1){
            return {
                isvalid: false
            };
        }

        var components = sqlDateString.indexOf(" ") > -1 ? sqlDateString.split(" ") : sqlDateString.split("T");
        if (components.length < 2){
            return {
                isvalid: false
            };           
        }

        var dateComponent = components[0];
        var dateComponents = dateComponent.split("-");
        if (dateComponents.length < 3){
            return {
                isvalid: false
            };
        }

        const [yearString, monthString, dayString] = dateComponents;

        const yearStringIsValid = yearString.length === 4 ? true: false;
        const monthStringIsValid = monthString.length === 2 ? true: false;
        const dayStringIsValid = dayString.length === 2 ? true: false;

        if (!yearStringIsValid || !monthStringIsValid || !dayStringIsValid){
            return {
                isvalid: false
            };
        }

        return {
            isvalid: true,
            year: parseInt(yearString),
            month: parseInt(monthString),
            day: parseInt(dayString)
        };
    }

    mapToSqlDateTime(date: Date): string{
        const dateComponent = `${date.getFullYear()}-${this.isoFyDateComponent(date.getMonth() + 1)}-${this.isoFyDateComponent(date.getDate())}`;
        return `${dateComponent}T00:00:00.000`;
    }

    //From machine format to human format
    getDisplayableDate(date: Date): string{
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    }

    // ISO date components like day and month need to be two digits
    isoFyDateComponent(dateComponent: number): string{
        const componentString = dateComponent.toString();
        return componentString.length === 1 ? `0${componentString[0]}` : componentString;
    }
}